/* eslint-disable @angular-eslint/no-input-rename */
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { SessionIdeaCardComponent } from '@components/sessions/single/idea-card/idea-card.component';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import _ from 'lodash';

import { Idea } from '../../../models/Sessions/Idea/Idea';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'idea-row',
  templateUrl: './idea-row.component.html',
  styleUrls: ['./idea-row.component.scss'],
})
export class IdeaRowComponent implements OnChanges, OnDestroy {
  @Input('row-title') title: string;
  @Input('row-description') description: string;
  @Input('empty-message') emptyMessage: string;
  @Input() ideas: Idea[];
  @Input('max-ideas') maxIdeas = 12;

  @ViewChildren(SessionIdeaCardComponent)
  cards: QueryList<SessionIdeaCardComponent>;
  @ViewChild('scrollpane', { static: true }) scrollpane: ElementRef;

  canScrollLeft = false;
  canScrollRight = false;
  updateScrollFeasibilityInterval: any;
  private onScrollActionsThrottled: any;

  constructor(
    private bus: BusService,
    private events: EventsService,
  ) {
    this.onScrollActionsThrottled = _.throttle(
      () => this.onScrollActions(),
      100,
      { leading: true },
    );
  }

  ngOnDestroy() {
    clearInterval(this.updateScrollFeasibilityInterval);
  }

  ngOnChanges() {
    if (this.ideas && this.ideas.length > this.maxIdeas) {
      this.ideas = [...this.ideas].splice(0, this.maxIdeas);
    }
  }

  scrollLeft() {
    this.scrollpane.nativeElement.scrollBy({
      left: -this.scrollpane.nativeElement.clientWidth * 0.75,
      behavior: 'smooth',
    });
  }

  scrollRight() {
    this.scrollpane.nativeElement.scrollBy({
      left: this.scrollpane.nativeElement.clientWidth * 0.75,
      behavior: 'smooth',
    });
  }

  openIdeaModal(idea) {
    this.bus.publish(
      this.events.requested.data.session.idea.singleWithSession,
      idea._id,
      idea.session._id,
    );
    this.bus.publish(
      this.events.requested.action.tracking.track,
      idea.session,
      'nav',
      'open idea',
      idea.title,
    );
  }

  onScrollActions() {
    if (this.scrollpane) {
      this.canScrollLeft = this.scrollpane.nativeElement.scrollLeft > 0;
      this.canScrollRight =
        this.scrollpane.nativeElement.scrollLeft <
        this.scrollpane.nativeElement.scrollWidth -
          this.scrollpane.nativeElement.clientWidth;
    }
  }

  handleScroll() {
    this.onScrollActionsThrottled();
  }
}
